import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

import { templateEmailNotificationHistoricalApi } from '@/main/api';
import KogModalFadeComponent from '@/main/components/modal/ModalFadeComponent';
import { TemplateEmailNotificationHistoricalDetailResponse } from '@/main/models/response/templateEmailNotificationResponse';
import { getTranslateByKey } from '@/main/services/utils';

import * as S from './styles';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';

interface IEmailTemplateHistoricalModalProps {
  isOpen: boolean;
  onClose: () => void;
  guid: string | null;
  defaultVariableNames?: string[];
}

function stripDefaultVariables(html: string, names: string[]): string {
  if (!names.length) return html;
  let result = html;
  names.forEach(name => {
    const clean = name.replace(/^\{\{|\}\}$/g, '').trim();
    result = result.replace(new RegExp(`\\{\\{\\s*${clean}\\s*\\}\\}`, 'g'), '');
  });
  return result;
}

function EmailTemplateHistoricalModal({
  isOpen,
  onClose,
  guid,
  defaultVariableNames = []
}: IEmailTemplateHistoricalModalProps) {
  const [data, setData] = useState<TemplateEmailNotificationHistoricalDetailResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !guid) {
      setData(null);
      return;
    }

    setIsLoading(true);
    templateEmailNotificationHistoricalApi
      .getDetailHistorical({ templateEmailNotificationCompanyHistoricalGuid: guid })
      .then(res => setData(res.data.result))
      .finally(() => setIsLoading(false));
  }, [isOpen, guid]);

  const title = data
    ? `${getTranslateByKey('information.changeDetails')} — ${data.cultureName}`
    : getTranslateByKey('information.changeDetails');

  return (
    <KogModalFadeComponent
      open={isOpen}
      setOpen={(value) => { if (!value) onClose(); }}
      title={title}
      hasBackgroundTitle
      closeByOverlay
    >
      <S.Container>

        <S.ModalContent>
          {isLoading ? (
            <S.LoadingWrapper>
              <CircularProgress size={32} />
            </S.LoadingWrapper>
          ) : data && (
            <>
              <S.Column>
                <S.ColumnLabel>{getTranslateByKey('information.previousVersion')}</S.ColumnLabel>
                <S.PreviewArea>
                  <S.SubjectHeading>{data.previousSubject}</S.SubjectHeading>
                  <div dangerouslySetInnerHTML={{ __html: stripDefaultVariables(data.previousBody, defaultVariableNames) }} />
                </S.PreviewArea>
              </S.Column>

              <S.Column>
                <S.ColumnLabel>{getTranslateByKey('information.savedVersion')}</S.ColumnLabel>
                <S.PreviewArea $bordered>
                  <S.SubjectHeading>{data.currentSubject}</S.SubjectHeading>
                  <div dangerouslySetInnerHTML={{ __html: stripDefaultVariables(data.currentBody, defaultVariableNames) }} />
                </S.PreviewArea>
              </S.Column>
            </>
          )}

        </S.ModalContent>
        <SecondaryButton
          onClick={onClose}
          id="id-button-close-modal-historical"
          style={{ alignSelf: 'center' }}
        >
          {getTranslateByKey('information.close')}
        </SecondaryButton>
      </S.Container>

    </KogModalFadeComponent >
  );
}

export default EmailTemplateHistoricalModal;

